import { Outlet } from 'react-router';
import { Settings } from 'lucide-react';
import { EncabezadoDePagina } from '@/shared/ui/EncabezadoDePagina';
import { PestanasDeConfiguracion } from './PestanasDeConfiguracion';

export function DisposicionDeConfiguracion() {
  return (
    <>
      <EncabezadoDePagina
        icono={Settings}
        color="pizarra"
        titulo="Configuración"
        subtitulo="Configuración del sistema"
      />
      <PestanasDeConfiguracion />
      <Outlet />
    </>
  );
}
